/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExposureStatus } from './ExposureStatus';
import {
    ExposureStatusFromJSON,
    ExposureStatusFromJSONTyped,
    ExposureStatusToJSON,
} from './ExposureStatus';
import type { GrowthAllocationType } from './GrowthAllocationType';
import {
    GrowthAllocationTypeFromJSON,
    GrowthAllocationTypeFromJSONTyped,
    GrowthAllocationTypeToJSON,
} from './GrowthAllocationType';

/**
 * 
 * @export
 * @interface GrowthAllocation
 */
export interface GrowthAllocation {
    /**
     * 
     * @type {number}
     * @memberof GrowthAllocation
     */
    targetGrowthSleeve?: number;
    /**
     * 
     * @type {number}
     * @memberof GrowthAllocation
     */
    actualUnencumberedCash?: number;
    /**
     * 
     * @type {number}
     * @memberof GrowthAllocation
     */
    currentLeverageRatio?: number;
    /**
     * 
     * @type {GrowthAllocationType}
     * @memberof GrowthAllocation
     */
    allocationType: GrowthAllocationType;
    /**
     * 
     * @type {ExposureStatus}
     * @memberof GrowthAllocation
     */
    exposureStatus?: ExposureStatus;
    /**
     * 
     * @type {number}
     * @memberof GrowthAllocation
     */
    currentWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof GrowthAllocation
     */
    targetWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof GrowthAllocation
     */
    activeWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof GrowthAllocation
     */
    currentExposure?: number;
    /**
     * 
     * @type {number}
     * @memberof GrowthAllocation
     */
    targetExposure?: number;
    /**
     * 
     * @type {number}
     * @memberof GrowthAllocation
     */
    activeExposure?: number;
}



/**
 * Check if a given object implements the GrowthAllocation interface.
 */
export function instanceOfGrowthAllocation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "allocationType" in value;

    return isInstance;
}

export function GrowthAllocationFromJSON(json: any): GrowthAllocation {
    return GrowthAllocationFromJSONTyped(json, false);
}

export function GrowthAllocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): GrowthAllocation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'targetGrowthSleeve': !exists(json, 'target_growth_sleeve') ? undefined : json['target_growth_sleeve'],
        'actualUnencumberedCash': !exists(json, 'actual_unencumbered_cash') ? undefined : json['actual_unencumbered_cash'],
        'currentLeverageRatio': !exists(json, 'current_leverage_ratio') ? undefined : json['current_leverage_ratio'],
        'allocationType': GrowthAllocationTypeFromJSON(json['allocation_type']),
        'exposureStatus': !exists(json, 'exposure_status') ? undefined : ExposureStatusFromJSON(json['exposure_status']),
        'currentWeight': !exists(json, 'current_weight') ? undefined : json['current_weight'],
        'targetWeight': !exists(json, 'target_weight') ? undefined : json['target_weight'],
        'activeWeight': !exists(json, 'active_weight') ? undefined : json['active_weight'],
        'currentExposure': !exists(json, 'current_exposure') ? undefined : json['current_exposure'],
        'targetExposure': !exists(json, 'target_exposure') ? undefined : json['target_exposure'],
        'activeExposure': !exists(json, 'active_exposure') ? undefined : json['active_exposure'],
    };
}

export function GrowthAllocationToJSON(value?: GrowthAllocation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'target_growth_sleeve': value.targetGrowthSleeve,
        'actual_unencumbered_cash': value.actualUnencumberedCash,
        'current_leverage_ratio': value.currentLeverageRatio,
        'allocation_type': GrowthAllocationTypeToJSON(value.allocationType),
        'exposure_status': ExposureStatusToJSON(value.exposureStatus),
        'current_weight': value.currentWeight,
        'target_weight': value.targetWeight,
        'active_weight': value.activeWeight,
        'current_exposure': value.currentExposure,
        'target_exposure': value.targetExposure,
        'active_exposure': value.activeExposure,
    };
}

